import { render, staticRenderFns } from "./LogoSingle.vue?vue&type=template&id=778dc6fb&scoped=true"
import script from "./LogoSingle.vue?vue&type=script&lang=ts"
export * from "./LogoSingle.vue?vue&type=script&lang=ts"
import style0 from "./LogoSingle.vue?vue&type=style&index=0&id=778dc6fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778dc6fb",
  null
  
)

export default component.exports